import React, { useState, useEffect } from 'react';

import {
    Accordion,
    AccordionContent,
    AccordionTitle,
    RadioWithLabel,
    Typography
} from '@hpstellar/core';

export default ({ clickOnEnter, sortValues, onSort, sortValue }) => {
    const [inpSort, setInpSort] = useState(null);

    useEffect(() => {
        if(typeof inpSort === 'string'){
            setInpSort(null);
        }
    }, [sortValue])

    const getOnChange = key => () => {
        setInpSort(key);
        setTimeout(() => {
            onSort(key);
        }, 0)
    }

    const derivedSort = typeof inpSort === 'string' ? inpSort : sortValue;
    return Array.isArray(sortValues) && (
        <Accordion className="mobileSort accordion" size="small" defaultExpanded>
            <AccordionTitle onKeyUp={clickOnEnter} title="SORT BY" />
            <AccordionContent className="accordionContent sortMobileContent">
                {sortValues.map(({ title, key }) => (
                    <RadioWithLabel checked={derivedSort === key} key={key}>
                        <RadioWithLabel.Label className="radioContainer">
                            <Typography>{title}</Typography>
                            <RadioWithLabel.Input value={key} onChange={getOnChange(key)} />
                        </RadioWithLabel.Label>
                    </RadioWithLabel>
                ))}
            </AccordionContent>
        </Accordion>
    )
}